export const concat = (text1?: string | null, text2?: string | null) => {
  return (text1 ?? "").concat(text2 ?? "")
}
